// FILE: /src/Components/Redirectpage/Facebook.js (FULLY UPDATED)

import React, { useEffect, useState, useRef } from "react";
import { Spin, message, Result, Button } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as authServices from '../../services/authConnect';
import { handleAuthSuccess } from "../../store/Slices/GroupSlice";
import PageSelectionView from "../Public/PageSelectionView";

export default function Facebook() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [status, setStatus] = useState('authenticating');
    const [error, setError] = useState('');
    const [selectionData, setSelectionData] = useState(null);
    const hasProcessedCallback = useRef(false);

    useEffect(() => {
        if (hasProcessedCallback.current) {
            return;
        }
        hasProcessedCallback.current = true;

        const handleCallback = async () => {
            if (window.location.hash === '#_=_') {
                const cleanUrl = window.location.href.split('#')[0];
                window.history.replaceState(null, document.title, cleanUrl);
            }
            const params = new URLSearchParams(window.location.search);
            
            const code = params.get('code');
            const state = params.get('state');

            if (code && state) {
                try {
                    const response = await authServices.handleCallback('FACEBOOK', code, state);
                    
                    if (response.requiresSelection) {
                        setSelectionData(response);
                        setStatus('selecting');
                    } else {
                        message.success("Facebook reconnected successfully!");
                        dispatch(handleAuthSuccess());
                        navigate('/Dashboard/GroupsProfile');
                    }
                } catch (err) {
                    setError(err.message || 'Failed to verify connection.');
                    setStatus('error');
                }
            } else {
                setError('Authentication was cancelled or failed.');
                setStatus('error');
            }
        };

        handleCallback();
    }, [dispatch, navigate, location]);

    const handleFinalize = async (selectedItems) => {
        if (selectedItems.length === 0) {
            message.info("Please select at least one page.");
            return;
        }
        setStatus('finalizing');
        try {
            const itemsToFinalize = selectedItems.map(item => ({
                platform: 'FACEBOOK',
                platform_pageId: item.id,
                platform_id: selectionData.facebookUserId,
                profile: item.name,
                accessToken: item.access_token,
            }));
            const result = await authServices.finalize('FACEBOOK', itemsToFinalize, selectionData.stateToken);
            if (result.partial) {
                message.warning(result.message, 10);
            } else {
                message.success(`${selectedItems.length} page(s) connected successfully!`);
            }
            dispatch(handleAuthSuccess());
            navigate('/Dashboard/GroupsProfile');
        } catch (err) {
            setError(err.message || "Failed to save selected pages.");
            setStatus('error');
        }
    };

    if (status === 'authenticating' || status === 'finalizing') {
        return (
            <div className="flex flex-col justify-center items-center h-screen">
                <Spin size="large" />
                <p className="mt-4 text-lg text-gray-600">{status === 'finalizing' ? 'Saving profiles...' : 'Authenticating with Facebook...'}</p>
            </div>
        );
    }
    
    if (status === 'error') {
        return (
             <Result
                status="error"
                title="Connection Failed"
                subTitle={error}
                extra={[ <Button type="primary" key="console" onClick={() => navigate('/Dashboard/GroupsProfile')}>Go to Brands & Channels</Button> ]}
            />
        );
    }

    if (status === 'selecting') {
        return (
            <PageSelectionView
                accounts={selectionData.pagesList || []}
                platformName="Facebook"
                onFinalize={handleFinalize}
                onCancel={() => navigate('/Dashboard/GroupsProfile')}
            />
        );
    }

    return null;
}